// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaNotFoundView.scss";
import CloseGif from "../../../../assets/close-gif.gif";
// project file imports(UI components) ⇒
import PrimaryButton from "../../../common/Buttons/PrimaryButton";

const AbhaNotFoundView = (props) => {
  // const declarations ⇒
  const { handleMobileNumberSteps } = props;

  // Actions ⇒
  const handleCreateAbha = () => {
    handleMobileNumberSteps(4);
  };

  // create UI ⇒

  const patientAbhaNotFound = () => {
    return (
      <div className="anfc-container">
        <div>
          <img src={CloseGif} alt="" />
        </div>
        <div className="anfc-text-container">
          <h6>ABHA Number Not Found</h6>
          <p>
            We did not find any ABHA number linked to this mobile number. Please
            use ABHA linked mobile number
          </p>
        </div>

        <div className="anfv-button-container">
          <PrimaryButton
            title="Create ABHA"
            handleButtonClick={handleCreateAbha}
          />
        </div>
      </div>
    );
  };

  return <div className="abha-not-found-view">{patientAbhaNotFound()}</div>;
};

// export ⇒

export default AbhaNotFoundView;
